import request from "../../../util/SuperagentUtils";
import { adminInvoicesReportEndpoints } from "../../api-endpoints";
import {SuperAgentRequest} from "superagent";

type AdminInvoiceQuery = {
  startDate?: string,
  endDate?: string,
  locationId?: string,
  transactionNumber?: string,
  bookingNumber?: string,
  assetType?: string,
  buyerAccountId?: string,
  supplierAccountId?: string,
  transactionType?: string,
  bookingStatus?: string,
  supplierTransactionStatus?: string,
  taxStatus?: string,
  paymentProcessor?: string,
  sortBy?: string,
  sortDir?: string,
  page?: number,
  size?: number
};

const requestAdminInvoices = (query: AdminInvoiceQuery) => {
  return request.get(adminInvoicesReportEndpoints.search).query(query);
};

const requestAdminInvoicesSummary: (query: {
  startDate?: string,
  endDate?: string,
  locationId?: string,
  transactionNumber?: string,
  bookingNumber?: string,
  assetType?: string,
  buyerAccountId?: string,
  supplierAccountId?: string,
  transactionType?: string,
  bookingStatus?: string,
  supplierTransactionStatus?: string,
  taxStatus?: string,
  paymentProcessor?: string
}) => SuperAgentRequest = (query) => {
  return request.get(adminInvoicesReportEndpoints.summary).query(query);
};

/**
 * Returns a URLSearchParams object with the given query parameters appended.
 * Params with values of null or undefined will not be included in the appended query params.
 *
 * @param query
 * @returns {URLSearchParams}
 */
const getQueryParams = (query: { [x: string]: unknown }): URLSearchParams => {
  const params = new URLSearchParams();

  Object.keys(query).forEach((key) => {
    const val = query[key];
    if (val != null && val !== '') {
      params.append(key, String(val));
    }
  });
  return params;
};

const getAdminInvoiceReportUrl = (query: Omit<AdminInvoiceQuery, 'page' | 'size'>) => {
  return `${adminInvoicesReportEndpoints.report}?${getQueryParams(query)}`;
}

/**
 * Returns the URL for the admin invoice group summary report with the given query parameters appended.
 * Params with values of null or undefined will not be included in the appended query params.
 *
 * @param query
 * @returns {`/api/admins/report/invoices/group-summary-report?${string}`}
 */
const getAdminInvoiceGroupSummaryReportUrl = (query: { [x: string]: unknown }): `/api/admins/report/invoices/group-summary-report?${string}` => {
  return `${adminInvoicesReportEndpoints.group}?${getQueryParams(query)}`;
};

export {
  requestAdminInvoices,
  requestAdminInvoicesSummary,
  getAdminInvoiceReportUrl,
  getAdminInvoiceGroupSummaryReportUrl,
};
